import { MembershipLevel, CurrentPayPlan, MembershipProductType } from '@ace-clublabs/common-membership-api-types';

export interface IGetNewBusinessCostRequest {
  membershipLevel: MembershipLevel;
  additionalMembers?: AssociateInfo[];
  products?: MembershipProductType[];
  promoCode?: string;
  billPlan: CurrentPayPlan;
  newJoinSessionId: string;
}

export interface IGetNewBusinessCostResponse {
  data: any;
  error?: {
    message: string;
  };
}

export type AssociateInfo = {
  virtualId: string | null;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: string | null;
  mobileNumber?: string | null;
  email?: string | null;
  gender: 'M' | 'F' | 'X' | null;
  roleType: RoleType;
};

export enum RoleType {
  PRIMARY = 'PR',
  ADULT_ASSOCIATE = 'AD',
  ASSOCIATE = 'AS',
  DEPENDENT = 'DE',
}
